import { useFeatureFlags } from '@atlassian/mpac-ui';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import CommonPropTypes from "../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetsHorizontalMenu from "./FacetsHorizontalMenu";
import FacetsVerticalMenu from "./FacetsVerticalMenu";
export default function FacetTopBar(props) {
  const {
    sortingLogicForCategoryFilter
  } = useFeatureFlags();
  return props.screenClass === 'xs' ? /*#__PURE__*/React.createElement(FacetsVerticalMenu, {
    displayTextSearch: props.displayTextSearch,
    facets: props.facets,
    filters: props.filters,
    hiddenFilters: props.hiddenFilters,
    itemFactory: props.itemFactory,
    perspective: props.perspective,
    screenClass: props.screenClass,
    stateChangeRequested: props.stateChangeRequested
  }) : /*#__PURE__*/React.createElement(FacetsHorizontalMenu, {
    displayTextSearch: props.displayTextSearch,
    facets: props.facets,
    filters: props.filters,
    hiddenFilters: props.hiddenFilters,
    itemFactory: props.itemFactory,
    perspective: props.perspective,
    screenClass: props.screenClass,
    sortingLogicForCategory: sortingLogicForCategoryFilter,
    stateChangeRequested: props.stateChangeRequested
  });
}
FacetTopBar.propTypes = {
  displayTextSearch: PropTypes.bool,
  facets: ImmutablePropTypes.list.isRequired,
  filters: CommonPropTypes.filters,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  screenClass: CommonPropTypes.screenClass.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
};